import React from 'react';

export const AppProviders = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
);
